<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Finish">
                <rect width="32" height="32"/>
            </clipPath>
        </defs>
        <g id="Finish" clip-path="url(#clip-Finish)">
            <rect width="34" height="34" style="fill:transparent"/>
            <g id="Group_13312" data-name="Group 13312">
                <path id="Path_41" data-name="Path 41" d="M0,0H36V36H0Z" class="svg-secondary-color" opacity="0"/>
                <path id="Path_42" data-name="Path 42" d="M8.385,11.115,15.27,18,8.385,24.885,10.5,27l9-9-9-9ZM24,9h3V27H24Z" class="svg-secondary-color"/>
            </g>
        </g>
    </svg>

</template>

<script>

export default {
    name: "finishIcon",

}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/finishIcon.vue